type Hook = (action: { type: string }) => void;

let beforeActionHook: Hook | null = null;
let afterActionHook: Hook | null = null;

/**
 * 注册 Action 执行前后的hooks
 *
 * NOTE: 不支持注册多个 hook function；后注册的会将之前覆盖；
 */
export const registerHooks = (hooks: { beforeAction?: Hook; afterAction?: Hook }): void => {
    if (typeof hooks.beforeAction === 'function') {
        beforeActionHook = hooks.beforeAction;
    }
    if (typeof hooks.afterAction === 'function') {
        afterActionHook = hooks.afterAction ;
    }
};

/**
 * 注销所有 hooks；
 *
 * 命名 https://english.stackexchange.com/questions/25931/unregister-vs-deregister
 */
export const deregisterHooks = (): void => {
    beforeActionHook = null;
    afterActionHook = null;
};

/**
 * 简易的 hooks middleware for redux
 */
export const hooksMiddleware = () => next => (action) => {
    beforeActionHook?.(action);
    const result = next(action);
    afterActionHook?.(action);
    return result;
};
